import angular from 'angular';
import highlight from './highlight';

/**
 * @name akamai.components.highlight
 * @description Provides highlight functionality while searching/filtering
 */
export default angular.module('akamai.components.highlight', [
])
/**
 * @name highlight
 * @param {string} text haystack to search through
 * @param {string} search needle to search for
 * @param {boolean} [caseSensitive=false] optional boolean to use case-sensitive searching
 * @description filter which can be used to show the user which portion of your search results
 * match the search term
 * @example <span ng-bind-html="item | highlight:searchTerm"></span>
 * Where: item = "Hello World" and search term is "world"
 * Outputs: `<span>Hello <span class="ui-match">World</span></span>`
 *
 */
.filter('highlight', highlight);
